export default "__VITE_ASSET__yeUoDDoz__"